import { render, staticRenderFns } from "./PluginAppearance.vue?vue&type=template&id=979e39ba"
import script from "./PluginAppearance.vue?vue&type=script&lang=js"
export * from "./PluginAppearance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports